import { useProgressStore } from '~/store/progress'
import { useRootStore } from '~/store/root'
import { useUserStore } from '~/store/user'

export default defineNuxtRouteMiddleware(async (to, from) => {
  const nuxtApp = useNuxtApp()
  const { $pinia, $lendioCookies } = nuxtApp

  const piniaUserStore = useUserStore($pinia)
  const piniaRootStore = useRootStore($pinia)
  const piniaProgressStore = useProgressStore($pinia)

  const query = to.query
  const oktaCode = query.code

  const data = await piniaUserStore.getOktaId({ oktaCode })
  if (piniaUserStore.signInError) {
    console.error('Sign in error', data)
    return
  }
  await piniaRootStore.getCurrentUser()
  piniaUserStore.setFreshLogin('signup')

  const inEmailVerificationTest = true // Turning off the test, but leaving the code in case we need to revert.
  if (
    !$lendioCookies.get('redirect') &&
    piniaRootStore.userProfile &&
    !piniaRootStore.userProfile.emailVerified &&
    !inEmailVerificationTest
  ) {
    return nuxtApp.runWithContext(() => navigateTo(
      {
        path: '/verify-email',
        query: { 'redirect': piniaProgressStore.appRoutePrefix + '/owner-info/owner-info-2' }
      },
      { redirectCode: 307 }
    ))
  }
  const path = $lendioCookies.get('redirect') || piniaProgressStore.appRoutePrefix + '/owner-info/owner-info-2'
  return nuxtApp.runWithContext(() => navigateTo({ path }, { redirectCode: 307 }))
})
